var _defs, _sodipodiNamedview, _g, _g2, _animateTransform;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 511.99999 512.00001",
    id: "svg10",
    width: 512,
    height: 512,
    sodipodiDocname: "logo512.svg",
    inkscapeVersion: "1.2.2 (b0a8486541, 2022-12-01)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs116"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview114",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    showgrid: "false",
    inkscapeZoom: 0.64938269,
    inkscapeCx: 49.277569,
    inkscapeCy: 107.79468,
    "inkscapeWindow-width": 1600,
    "inkscapeWindow-height": 868,
    "inkscapeWindow-x": 1366,
    "inkscapeWindow-y": 0,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "logo"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6177",
    transform: "translate(-247.30404,-305.33688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3861"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1484873,-0.74910445,0.77000966,1.1805381,-318.4378,391.45208)",
    id: "logo",
    style: {
      stroke: "#000000",
      strokeWidth: 0.719322,
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2000",
    transform: "translate(-0.01769463,0.0120775)",
    "inkscapeExport-filename": "g2000.png",
    "inkscapeExport-xdpi": 96,
    "inkscapeExport-ydpi": 96
  }, /*#__PURE__*/React.createElement("g", {
    id: "g379",
    transform: "matrix(1.2798743,1.005399e-4,1.0626799e-4,1.2797832,-107.15723,-50.054302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "circle899",
    d: "m 390.41824,318.66837 a 7.1706538,7.1712461 0 0 1 -7.17065,7.17124 7.1706538,7.1712461 0 0 1 -7.17065,-7.17124 7.1706538,7.1712461 0 0 1 7.17065,-7.17125 7.1706538,7.1712461 0 0 1 7.17065,7.17125 z",
    style: {
      opacity: 1,
      fill: "#000000",
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "rotate(-5.8559837)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00ff00",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 425.81056,242.21628 Z",
    id: "path901"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 412.62198,266.72387 a 11.417575,53.991157 84.144016 0 0 -52.54436,16.8668 11.417575,53.991157 84.144016 0 0 54.87421,5.84927 11.417575,53.991157 84.144016 0 0 52.5447,-16.86653 11.417575,53.991157 84.144016 0 0 -54.87455,-5.84954 z m 0.0802,0.78233 a 10.631227,50.27269 84.144016 0 1 51.09514,5.44661 10.631227,50.27269 84.144016 0 1 -48.92577,15.70479 10.631227,50.27269 84.144016 0 1 -51.0948,-5.44633 10.631227,50.27269 84.144016 0 1 48.92543,-15.70507 z",
    id: "path903"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path905",
    d: "m 403.47128,273.18996 a 11.416886,53.994418 25.367507 0 0 -12.81671,53.68015 11.416886,53.994418 25.367507 0 0 33.44814,-43.89602 11.416886,53.994418 25.367507 0 0 12.81711,-53.68029 11.416886,53.994418 25.367507 0 0 -33.44854,43.89616 z m 0.71054,0.33696 a 10.630585,50.275726 25.367507 0 1 31.14477,-40.8729 10.630585,50.275726 25.367507 0 1 -11.93442,49.98311 10.630585,50.275726 25.367507 0 1 -31.14437,40.87276 10.630585,50.275726 25.367507 0 1 11.93402,-49.98297 z",
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path907",
    d: "m 422.92592,271.23884 a 53.994435,11.416882 53.179809 0 0 -41.49834,-36.38043 53.994435,11.416882 53.179809 0 0 23.22043,50.06628 53.994435,11.416882 53.179809 0 0 41.49828,36.38085 53.994435,11.416882 53.179809 0 0 -23.22037,-50.0667 z m -0.62948,0.47133 a 50.275742,10.630581 53.179809 0 1 21.62114,46.61841 50.275742,10.630581 53.179809 0 1 -38.64009,-33.87523 50.275742,10.630581 53.179809 0 1 -21.6212,-46.61797 50.275742,10.630581 53.179809 0 1 38.64015,33.87479 z",
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle909",
    d: "m 390.41824,318.66837 a 7.1706538,7.1712461 0 0 1 -7.17065,7.17124 7.1706538,7.1712461 0 0 1 -7.17065,-7.17124 7.1706538,7.1712461 0 0 1 7.17065,-7.17125 7.1706538,7.1712461 0 0 1 7.17065,7.17125 z",
    style: {
      opacity: 1,
      fill: "#e8340f",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "rotate(-5.8559837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "m 495.92817,303.45225 a 11.417575,53.991157 84.144016 0 0 -52.54436,16.8668 11.417575,53.991157 84.144016 0 0 54.87421,5.84927 11.417575,53.991157 84.144016 0 0 52.5447,-16.86653 11.417575,53.991157 84.144016 0 0 -54.87455,-5.84954 z m 0.0802,0.78233 a 10.631227,50.27269 84.144016 0 1 51.09514,5.44661 10.631227,50.27269 84.144016 0 1 -48.92577,15.70479 10.631227,50.27269 84.144016 0 1 -51.0948,-5.44633 10.631227,50.27269 84.144016 0 1 48.92543,-15.70507 z",
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 486.77747,309.91834 a 11.416886,53.994418 25.367507 0 0 -12.81671,53.68015 11.416886,53.994418 25.367507 0 0 33.44814,-43.89602 11.416886,53.994418 25.367507 0 0 12.81711,-53.68029 11.416886,53.994418 25.367507 0 0 -33.44854,43.89616 z m 0.71054,0.33696 a 10.630585,50.275726 25.367507 0 1 31.14477,-40.8729 10.630585,50.275726 25.367507 0 1 -11.93442,49.98311 10.630585,50.275726 25.367507 0 1 -31.14437,40.87276 10.630585,50.275726 25.367507 0 1 11.93402,-49.98297 z",
    id: "path840"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 506.23211,307.96722 a 53.994435,11.416882 53.179809 0 0 -41.49834,-36.38043 53.994435,11.416882 53.179809 0 0 23.22043,50.06628 53.994435,11.416882 53.179809 0 0 41.49828,36.38085 53.994435,11.416882 53.179809 0 0 -23.22037,-50.0667 z m -0.62948,0.47133 a 50.275742,10.630581 53.179809 0 1 21.62114,46.61841 50.275742,10.630581 53.179809 0 1 -38.64009,-33.87523 50.275742,10.630581 53.179809 0 1 -21.6212,-46.61797 50.275742,10.630581 53.179809 0 1 38.64015,33.87479 z",
    id: "path842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle844",
    d: "m 469.54236,363.70465 a 7.1706538,7.1712461 0 0 1 -7.17066,7.17125 7.1706538,7.1712461 0 0 1 -7.17065,-7.17125 7.1706538,7.1712461 0 0 1 7.17065,-7.17125 7.1706538,7.1712461 0 0 1 7.17066,7.17125 z",
    style: {
      opacity: 1,
      fill: "#fff300",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "rotate(-5.8559837)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g854",
    style: {
      opacity: 1,
      fill: "none",
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.15608826,-0.01600897,0.01601029,0.15610115,352.41058,326.99961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "circle834",
    d: "m 466.59999,296.5 a 45.700001,45.700001 0 0 1 -45.7,45.7 45.700001,45.700001 0 0 1 -45.7,-45.7 45.700001,45.700001 0 0 1 45.7,-45.7 45.700001,45.700001 0 0 1 45.7,45.7 z",
    style: {
      fill: "none",
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path836",
    d: "M 520.5,78.1 Z",
    style: {
      fill: "none",
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path838",
    d: "M 420.94922,224.88867 A 344.09637,72.760468 0 0 0 76.853516,297.65039 344.09637,72.760468 0 0 0 420.94922,370.41016 344.09637,72.760468 0 0 0 765.04688,297.65039 344.09637,72.760468 0 0 0 420.94922,224.88867 Z m 0,5.01172 a 320.39784,67.749325 0 0 1 320.39844,67.75 320.39784,67.749325 0 0 1 -320.39844,67.74805 320.39784,67.749325 0 0 1 -320.39649,-67.74805 320.39784,67.749325 0 0 1 320.39649,-67.75 z",
    style: {
      opacity: 0.662,
      fill: "none",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.662,
      fill: "none",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "M 358.72972,259.93022 A 72.760468,344.09637 31.225784 0 0 242.56723,591.89767 72.760468,344.09637 31.225784 0 0 483.16966,335.37028 72.760468,344.09637 31.225784 0 0 599.33484,3.4021612 72.760468,344.09637 31.225784 0 0 358.72972,259.93022 Z m 4.28567,2.59812 A 67.749325,320.39784 31.225784 0 1 587.04889,23.668098 67.749325,320.39784 31.225784 0 1 478.88399,332.77215 67.749325,320.39784 31.225784 0 1 254.85318,571.63174 67.749325,320.39784 31.225784 0 1 363.01539,262.52834 Z",
    id: "path841"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.662,
      fill: "none",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "M 483.33973,260.2105 A 344.09637,72.760468 59.033509 0 0 243.89899,2.5978936 344.09637,72.760468 59.033509 0 0 358.55965,335.08664 344.09637,72.760468 59.033509 0 0 597.99973,592.70194 344.09637,72.760468 59.033509 0 0 483.33973,260.2105 Z m -4.29739,2.57872 A 320.39784,67.749325 59.033509 0 1 585.80561,572.3806 320.39784,67.749325 59.033509 0 1 362.85704,332.50794 320.39784,67.749325 59.033509 0 1 256.09312,22.919221 320.39784,67.749325 59.033509 0 1 479.04234,262.78922 Z",
    id: "path843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path847",
    d: "m 270.83062,107.19853 a 17.179554,17.179554 0 0 1 -17.17956,17.17956 17.179554,17.179554 0 0 1 -17.17955,-17.17956 17.179554,17.179554 0 0 1 17.17955,-17.179552 17.179554,17.179554 0 0 1 17.17956,17.179552 z",
    style: {
      opacity: 0.662,
      fill: "none",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.662,
      fill: "none",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 270.83062,485.14873 a 17.179554,17.179554 0 0 1 -17.17956,17.17956 17.179554,17.179554 0 0 1 -17.17955,-17.17956 17.179554,17.179554 0 0 1 17.17955,-17.17955 17.179554,17.179554 0 0 1 17.17956,17.17955 z",
    id: "path849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path852",
    d: "m 600.44001,233.1597 a 17.179554,17.179554 0 0 1 -17.17956,17.17956 17.179554,17.179554 0 0 1 -17.17955,-17.17956 17.179554,17.179554 0 0 1 17.17955,-17.17955 17.179554,17.179554 0 0 1 17.17956,17.17955 z",
    style: {
      opacity: 0.662,
      fill: "none",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.15608826,-0.01600897,0.01601029,0.15610115,343.17963,332.68337)",
    style: {
      opacity: 1,
      fill: "none",
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "g1007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "circle989",
    d: "m 466.59999,296.5 a 45.700001,45.700001 0 0 1 -45.7,45.7 45.700001,45.700001 0 0 1 -45.7,-45.7 45.700001,45.700001 0 0 1 45.7,-45.7 45.700001,45.700001 0 0 1 45.7,45.7 z",
    style: {
      fill: "none",
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.662,
      fill: "none",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "M 420.94922,224.88867 A 344.09637,72.760468 0 0 0 76.853516,297.65039 344.09637,72.760468 0 0 0 420.94922,370.41016 344.09637,72.760468 0 0 0 765.04688,297.65039 344.09637,72.760468 0 0 0 420.94922,224.88867 Z m 0,5.01172 a 320.39784,67.749325 0 0 1 320.39844,67.75 320.39784,67.749325 0 0 1 -320.39844,67.74805 320.39784,67.749325 0 0 1 -320.39649,-67.74805 320.39784,67.749325 0 0 1 320.39649,-67.75 z",
    id: "path993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path995",
    d: "M 358.72972,259.93022 A 72.760468,344.09637 31.225784 0 0 242.56723,591.89767 72.760468,344.09637 31.225784 0 0 483.16966,335.37028 72.760468,344.09637 31.225784 0 0 599.33484,3.4021612 72.760468,344.09637 31.225784 0 0 358.72972,259.93022 Z m 4.28567,2.59812 A 67.749325,320.39784 31.225784 0 1 587.04889,23.668098 67.749325,320.39784 31.225784 0 1 478.88399,332.77215 67.749325,320.39784 31.225784 0 1 254.85318,571.63174 67.749325,320.39784 31.225784 0 1 363.01539,262.52834 Z",
    style: {
      opacity: 0.662,
      fill: "none",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path997",
    d: "M 483.33973,260.2105 A 344.09637,72.760468 59.033509 0 0 243.89899,2.5978936 344.09637,72.760468 59.033509 0 0 358.55965,335.08664 344.09637,72.760468 59.033509 0 0 597.99973,592.70194 344.09637,72.760468 59.033509 0 0 483.33973,260.2105 Z m -4.29739,2.57872 A 320.39784,67.749325 59.033509 0 1 585.80561,572.3806 320.39784,67.749325 59.033509 0 1 362.85704,332.50794 320.39784,67.749325 59.033509 0 1 256.09312,22.919221 320.39784,67.749325 59.033509 0 1 479.04234,262.78922 Z",
    style: {
      opacity: 0.662,
      fill: "none",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.662,
      fill: "none",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 275.11807,122.91919 a 17.179554,17.179554 0 0 1 -17.17956,17.17956 17.179554,17.179554 0 0 1 -17.17955,-17.17956 17.179554,17.179554 0 0 1 17.17955,-17.17956 17.179554,17.179554 0 0 1 17.17956,17.17956 z",
    id: "path1001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1003",
    d: "m 272.97435,474.4301 a 17.179554,17.179554 0 0 1 -17.17956,17.17956 17.179554,17.179554 0 0 1 -17.17955,-17.17956 17.179554,17.179554 0 0 1 17.17955,-17.17955 17.179554,17.179554 0 0 1 17.17956,17.17955 z",
    style: {
      opacity: 0.662,
      fill: "none",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.662,
      fill: "none",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 744.78421,268.88846 a 17.179554,17.179554 0 0 1 -17.17956,17.17956 17.179554,17.179554 0 0 1 -17.17955,-17.17956 17.179554,17.179554 0 0 1 17.17955,-17.17955 17.179554,17.179554 0 0 1 17.17956,17.17955 z",
    id: "path1005"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 517.29567,368.10955 Z",
    id: "path1011",
    style: {
      opacity: 1,
      fill: "#000000",
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 504.10709,392.61714 a 11.417575,53.991157 84.144016 0 0 -52.54436,16.8668 11.417575,53.991157 84.144016 0 0 54.87421,5.84927 11.417575,53.991157 84.144016 0 0 52.5447,-16.86653 11.417575,53.991157 84.144016 0 0 -54.87455,-5.84954 z m 0.0802,0.78233 a 10.631227,50.27269 84.144016 0 1 51.09514,5.44661 10.631227,50.27269 84.144016 0 1 -48.92577,15.70479 10.631227,50.27269 84.144016 0 1 -51.0948,-5.44633 10.631227,50.27269 84.144016 0 1 48.92543,-15.70507 z",
    id: "path1013"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1015",
    d: "m 494.95639,399.08323 a 11.416886,53.994418 25.367507 0 0 -12.81671,53.68015 11.416886,53.994418 25.367507 0 0 33.44814,-43.89602 11.416886,53.994418 25.367507 0 0 12.81711,-53.68029 11.416886,53.994418 25.367507 0 0 -33.44854,43.89616 z m 0.71054,0.33696 a 10.630585,50.275726 25.367507 0 1 31.14477,-40.8729 10.630585,50.275726 25.367507 0 1 -11.93442,49.98311 10.630585,50.275726 25.367507 0 1 -31.14437,40.87276 10.630585,50.275726 25.367507 0 1 11.93402,-49.98297 z",
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1017",
    d: "m 514.41103,397.13211 a 53.994435,11.416882 53.179809 0 0 -41.49834,-36.38043 53.994435,11.416882 53.179809 0 0 23.22043,50.06628 53.994435,11.416882 53.179809 0 0 41.49828,36.38085 53.994435,11.416882 53.179809 0 0 -23.22037,-50.0667 z m -0.62948,0.47133 a 50.275742,10.630581 53.179809 0 1 21.62114,46.61841 50.275742,10.630581 53.179809 0 1 -38.64009,-33.87523 50.275742,10.630581 53.179809 0 1 -21.6212,-46.61797 50.275742,10.630581 53.179809 0 1 38.64015,33.87479 z",
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1019",
    d: "m 468.58127,453.23874 a 7.1706538,7.1712461 0 0 1 -7.17066,7.17125 7.1706538,7.1712461 0 0 1 -7.17065,-7.17125 7.1706538,7.1712461 0 0 1 7.17065,-7.17125 7.1706538,7.1712461 0 0 1 7.17066,7.17125 z",
    style: {
      opacity: 1,
      fill: "#77ff00",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "rotate(-5.8559837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1033",
    d: "m 429.89526,444.53092 a 11.417575,53.991157 84.144016 0 0 -52.54436,16.8668 11.417575,53.991157 84.144016 0 0 54.87421,5.84927 11.417575,53.991157 84.144016 0 0 52.5447,-16.86653 11.417575,53.991157 84.144016 0 0 -54.87455,-5.84954 z m 0.0802,0.78233 a 10.631227,50.27269 84.144016 0 1 51.09514,5.44661 10.631227,50.27269 84.144016 0 1 -48.92577,15.70479 10.631227,50.27269 84.144016 0 1 -51.0948,-5.44633 10.631227,50.27269 84.144016 0 1 48.92543,-15.70507 z",
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 420.74456,450.99701 a 11.416886,53.994418 25.367507 0 0 -12.81671,53.68015 11.416886,53.994418 25.367507 0 0 33.44814,-43.89602 11.416886,53.994418 25.367507 0 0 12.81711,-53.68029 11.416886,53.994418 25.367507 0 0 -33.44854,43.89616 z m 0.71054,0.33696 a 10.630585,50.275726 25.367507 0 1 31.14477,-40.8729 10.630585,50.275726 25.367507 0 1 -11.93442,49.98311 10.630585,50.275726 25.367507 0 1 -31.14437,40.87276 10.630585,50.275726 25.367507 0 1 11.93402,-49.98297 z",
    id: "path1035"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 440.1992,449.04589 a 53.994435,11.416882 53.179809 0 0 -41.49834,-36.38043 53.994435,11.416882 53.179809 0 0 23.22043,50.06628 53.994435,11.416882 53.179809 0 0 41.49828,36.38085 53.994435,11.416882 53.179809 0 0 -23.22037,-50.0667 z m -0.62948,0.47133 a 50.275742,10.630581 53.179809 0 1 21.62114,46.61841 50.275742,10.630581 53.179809 0 1 -38.64009,-33.87523 50.275742,10.630581 53.179809 0 1 -21.6212,-46.61797 50.275742,10.630581 53.179809 0 1 38.64015,33.87479 z",
    id: "path1037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1039",
    d: "m 389.46002,497.30988 a 7.1706538,7.1712461 0 0 1 -7.17065,7.17124 7.1706538,7.1712461 0 0 1 -7.17066,-7.17124 7.1706538,7.1712461 0 0 1 7.17066,-7.17125 7.1706538,7.1712461 0 0 1 7.17065,7.17125 z",
    style: {
      opacity: 1,
      fill: "#f10ca5",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "rotate(-5.8559837)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00ff00",
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 351.66277,294.75447 Z",
    id: "path1053"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 338.47419,319.26206 a 11.417575,53.991157 84.144016 0 0 -52.54436,16.8668 11.417575,53.991157 84.144016 0 0 54.87421,5.84927 11.417575,53.991157 84.144016 0 0 52.5447,-16.86653 11.417575,53.991157 84.144016 0 0 -54.87455,-5.84954 z m 0.0802,0.78233 a 10.631227,50.27269 84.144016 0 1 51.09514,5.44661 10.631227,50.27269 84.144016 0 1 -48.92577,15.70479 10.631227,50.27269 84.144016 0 1 -51.0948,-5.44633 10.631227,50.27269 84.144016 0 1 48.92543,-15.70507 z",
    id: "cyan-path1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1057",
    d: "m 329.32349,325.72815 a 11.416886,53.994418 25.367507 0 0 -12.81671,53.68015 11.416886,53.994418 25.367507 0 0 33.44814,-43.89602 11.416886,53.994418 25.367507 0 0 12.81711,-53.68029 11.416886,53.994418 25.367507 0 0 -33.44854,43.89616 z m 0.71054,0.33696 a 10.630585,50.275726 25.367507 0 1 31.14477,-40.8729 10.630585,50.275726 25.367507 0 1 -11.93442,49.98311 10.630585,50.275726 25.367507 0 1 -31.14437,40.87276 10.630585,50.275726 25.367507 0 1 11.93402,-49.98297 z",
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1059",
    d: "m 348.77813,323.77703 a 53.994435,11.416882 53.179809 0 0 -41.49834,-36.38043 53.994435,11.416882 53.179809 0 0 23.22043,50.06628 53.994435,11.416882 53.179809 0 0 41.49828,36.38085 53.994435,11.416882 53.179809 0 0 -23.22037,-50.0667 z m -0.62948,0.47133 a 50.275742,10.630581 53.179809 0 1 21.62114,46.61841 50.275742,10.630581 53.179809 0 1 -38.64009,-33.87523 50.275742,10.630581 53.179809 0 1 -21.6212,-46.61797 50.275742,10.630581 53.179809 0 1 38.64015,33.87479 z",
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1061",
    d: "m 311.29703,363.36719 a 7.1706538,7.1712461 0 0 1 -7.17066,7.17124 7.1706538,7.1712461 0 0 1 -7.17065,-7.17124 7.1706538,7.1712461 0 0 1 7.17065,-7.17125 7.1706538,7.1712461 0 0 1 7.17066,7.17125 z",
    style: {
      opacity: 1,
      fill: "#0fdff1",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "rotate(-5.8559837)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 347.56855,407.90422 a 11.417575,53.991157 84.144016 0 0 -52.54436,16.8668 11.417575,53.991157 84.144016 0 0 54.87421,5.84927 11.417575,53.991157 84.144016 0 0 52.5447,-16.86653 11.417575,53.991157 84.144016 0 0 -54.87455,-5.84954 z m 0.0802,0.78233 a 10.631227,50.27269 84.144016 0 1 51.09514,5.44661 10.631227,50.27269 84.144016 0 1 -48.92577,15.70479 10.631227,50.27269 84.144016 0 1 -51.0948,-5.44633 10.631227,50.27269 84.144016 0 1 48.92543,-15.70507 z",
    id: "purple-path1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1097",
    d: "m 338.41785,414.37031 a 11.416886,53.994418 25.367507 0 0 -12.81671,53.68015 11.416886,53.994418 25.367507 0 0 33.44814,-43.89602 11.416886,53.994418 25.367507 0 0 12.81711,-53.68029 11.416886,53.994418 25.367507 0 0 -33.44854,43.89616 z m 0.71054,0.33696 a 10.630585,50.275726 25.367507 0 1 31.14477,-40.8729 10.630585,50.275726 25.367507 0 1 -11.93442,49.98311 10.630585,50.275726 25.367507 0 1 -31.14437,40.87276 10.630585,50.275726 25.367507 0 1 11.93402,-49.98297 z",
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "purple-path2",
    d: "m 357.87249,412.41919 a 53.994435,11.416882 53.179809 0 0 -41.49834,-36.38043 53.994435,11.416882 53.179809 0 0 23.22043,50.06628 53.994435,11.416882 53.179809 0 0 41.49828,36.38085 53.994435,11.416882 53.179809 0 0 -23.22037,-50.0667 z m -0.62948,0.47133 a 50.275742,10.630581 53.179809 0 1 21.62114,46.61841 50.275742,10.630581 53.179809 0 1 -38.64009,-33.87523 50.275742,10.630581 53.179809 0 1 -21.6212,-46.61797 50.275742,10.630581 53.179809 0 1 38.64015,33.87479 z",
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#00ff00",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "purple-path3",
    d: "m 311.2999,452.47467 a 7.1706538,7.1712461 0 0 1 -7.17066,7.17125 7.1706538,7.1712461 0 0 1 -7.17065,-7.17125 7.1706538,7.1712461 0 0 1 7.17065,-7.17125 7.1706538,7.1712461 0 0 1 7.17066,7.17125 z",
    style: {
      opacity: 1,
      fill: "#4b03e9",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "rotate(-5.8559837)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#000000",
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1073",
    d: "M 434.96896,331.48285 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "black-path1",
    d: "m 421.78038,355.99044 a 11.417575,53.991157 84.144016 0 0 -52.54436,16.8668 11.417575,53.991157 84.144016 0 0 54.87421,5.84927 11.417575,53.991157 84.144016 0 0 52.5447,-16.86653 11.417575,53.991157 84.144016 0 0 -54.87455,-5.84954 z m 0.0802,0.78233 a 10.631227,50.27269 84.144016 0 1 51.09514,5.44661 10.631227,50.27269 84.144016 0 1 -48.92577,15.70479 10.631227,50.27269 84.144016 0 1 -51.0948,-5.44633 10.631227,50.27269 84.144016 0 1 48.92543,-15.70507 z",
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 412.62968,362.45653 a 11.416886,53.994418 25.367507 0 0 -12.81671,53.68015 11.416886,53.994418 25.367507 0 0 33.44814,-43.89602 11.416886,53.994418 25.367507 0 0 12.81711,-53.68029 11.416886,53.994418 25.367507 0 0 -33.44854,43.89616 z m 0.71054,0.33696 a 10.630585,50.275726 25.367507 0 1 31.14477,-40.8729 10.630585,50.275726 25.367507 0 1 -11.93442,49.98311 10.630585,50.275726 25.367507 0 1 -31.14437,40.87276 10.630585,50.275726 25.367507 0 1 11.93402,-49.98297 z",
    id: "black-path3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 432.08432,360.50541 a 53.994435,11.416882 53.179809 0 0 -41.49834,-36.38043 53.994435,11.416882 53.179809 0 0 23.22043,50.06628 53.994435,11.416882 53.179809 0 0 41.49828,36.38085 53.994435,11.416882 53.179809 0 0 -23.22037,-50.0667 z m -0.62948,0.47133 a 50.275742,10.630581 53.179809 0 1 21.62114,46.61841 50.275742,10.630581 53.179809 0 1 -38.64009,-33.87523 50.275742,10.630581 53.179809 0 1 -21.6212,-46.61797 50.275742,10.630581 53.179809 0 1 38.64015,33.87479 z",
    id: "black-path2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1081",
    d: "m 390.42114,408.4035 a 7.1706538,7.1712461 0 0 1 -7.17065,7.17125 7.1706538,7.1712461 0 0 1 -7.17066,-7.17125 7.1706538,7.1712461 0 0 1 7.17066,-7.17124 7.1706538,7.1712461 0 0 1 7.17065,7.17124 z",
    style: {
      opacity: 1,
      fill: "#020202",
      fillOpacity: 1,
      stroke: "#f70808",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "rotate(-5.8559837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1208",
    d: "M 568.75972,366.93637 A 145.85799,141.89804 0 0 1 422.90173,508.83441 145.85799,141.89804 0 0 1 277.04375,366.93637 145.85799,141.89804 0 0 1 422.90173,225.03833 145.85799,141.89804 0 0 1 568.75972,366.93637 Z",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#f70808",
      strokeWidth: 0,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1242",
    transform: "rotate(-148.81245,420.5242,298.0846)"
  }))), /*#__PURE__*/React.createElement("g", {
    "aria-label": "(V)",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none"
    },
    id: "text3026"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g5289",
    transform: "translate(118.846,-171.35352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5294",
    transform: "rotate(-23.237821,301.84645,279.09297)"
  }))), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 0 0",
    to: "360 0 0",
    begin: "0s",
    dur: "30s",
    repeatCount: "indefinite"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dc37da14d76771ccb6c9543c620f2255.svg";
export { ForwardRef as ReactComponent };